<template lang="pug">
  div
    //- top-nav(headerColor="white")
    //- .placeholder(v-if="loading")
    div.qr-photo-container
      img(:src="currentPhoto")
    div.qr-code-captions
      p(v-html="caption")
    //- bottom-nav(footerColor="white")
</template>

<script>
import ComponentMixin from '@/mixins/ComponentMixin'
import captions from '@/../static/json/qr.json'

export default {
  name: 'single-image',
  mixins: [ComponentMixin],

  computed: {
    photoId: function () {
      console.log(captions)
      return this.$route.params.id
    },

    currentPhoto: function () {
      return '/static/images/qr/' + this.photoId + '.jpg'
    },

    caption: function () {
      return captions[this.photoId]
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_variables'

  .qr-photo-container
    max-height: 90vh
    margin: auto
    display: flex
    justify-content: center
    align-items: center
    img
      max-height: 70vh
      width: 80vw
      object-fit: contain
      margin-top: 10rem
  .qr-code-captions
    width: 80vw
    margin: 5rem auto 15rem auto
    *
      font-size: 2.4rem !important
</style>



// WEBPACK FOOTER //
// SingleImage.vue?e865add8